/**
 * @generated SignedSource<<ca990a1b5a8c8e3e8c05e582c107f918>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LikeEpisodeInput = {
  episodeId: string;
  topicSlug: string;
};
export type EpisodeListLikeMutation$variables = {
  input: LikeEpisodeInput;
};
export type EpisodeListLikeMutation$data = {
  readonly likeEpisode: {
    readonly episode: {
      readonly id: string;
      readonly isLikedByViewer: boolean | null | undefined;
      readonly likeCount: number;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type EpisodeListLikeMutation = {
  response: EpisodeListLikeMutation$data;
  variables: EpisodeListLikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LikeEpisodePayload",
    "kind": "LinkedField",
    "name": "likeEpisode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Episode",
        "kind": "LinkedField",
        "name": "episode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLikedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "likeCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EpisodeListLikeMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EpisodeListLikeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8eccfed5bfdf962d09393111369d4f18",
    "id": null,
    "metadata": {},
    "name": "EpisodeListLikeMutation",
    "operationKind": "mutation",
    "text": "mutation EpisodeListLikeMutation(\n  $input: LikeEpisodeInput!\n) {\n  likeEpisode(input: $input) {\n    episode {\n      id\n      isLikedByViewer\n      likeCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d6572ced1df20752ac6f7aab1a1fb05";

export default node;
